import { HistoryEvent } from '@api/types';
import { isUninstallEvent } from '@react/constants/historyEvent/utils';

class UninstallPrepareNameParser {
  check = isUninstallEvent;

  getName(event: HistoryEvent): string {
    const { store } = event.attributes.parameters;
    return `${event.attributes.name}@${store}`;
  }
}

export const uninstallPrepareNameParser = new UninstallPrepareNameParser();
